import { memo } from 'react';

/**
 * Sidebar showing details of a selected edge (dependency relationship)
 */
function EdgeDetailsSidebar({ edge, onClose, onShowCallGraph, onExploreModules }) {
  if (!edge) return null;

  const { sourceNode, targetNode, data } = edge;
  const isCycle = data?.isCycle;
  const isCrossBoundary = data?.isCrossBoundary;
  const symbols = data?.symbols || [];

  const sourceName = sourceNode?.data?.label || edge.source;
  const targetName = targetNode?.data?.label || edge.target;

  return (
    <div className="details-sidebar">
      <div className="sidebar-header">
        <h3>Edge Details</h3>
        <button className="close-btn" onClick={onClose} title="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <div className="sidebar-body">
        {/* Relationship Title */}
        <div className="relationship-title">
          {sourceName} <span className="arrow">→</span> {targetName}
        </div>

        {/* Dependency Info Section */}
        <div className="info-section">
          <h4 className="section-label">Dependency Info</h4>

          <div className="info-row">
            <span className="info-key">Type:</span>
            <span className="info-val highlight">Import</span>
            <span className="info-val"> Relationship</span>
          </div>

          {isCycle && (
            <div className="info-row cycle">
              <span className="info-key warning">Cycle Detected:</span>
              <span className="info-val">In Circular Dependency</span>
            </div>
          )}

          {isCrossBoundary && (
            <div className="info-row">
              <span className="info-key">Boundary:</span>
              <span className="layer-tag" style={{ backgroundColor: sourceNode?.data?.boundary?.color }}>
                {data.sourceLayer}
              </span>
              <span className="arrow-small">→</span>
              <span className="layer-tag" style={{ backgroundColor: targetNode?.data?.boundary?.color }}>
                {data.targetLayer}
              </span>
            </div>
          )}
        </div>

        {/* Found In Section */}
        {symbols.length > 0 && (
          <div className="info-section">
            <h4 className="section-label">Imported Symbols</h4>
            <div className="symbol-list">
              {symbols.slice(0, 6).map((sym, i) => (
                <div key={i} className="symbol-item">
                  <code>{sym}</code>
                </div>
              ))}
              {symbols.length > 6 && (
                <div className="symbol-more">+{symbols.length - 6} more symbols</div>
              )}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="sidebar-actions">
          <button
            className="action-btn primary"
            onClick={() => onShowCallGraph?.(edge)}
          >
            Show Call Sites
          </button>
          <button
            className="action-btn secondary"
            onClick={() => onExploreModules?.(targetNode)}
          >
            Open Module
          </button>
        </div>
      </div>
    </div>
  );
}

export default memo(EdgeDetailsSidebar);
